import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-service-manual',
  templateUrl: './service-manual.component.html',
  styleUrls: ['./service-manual.component.sass'],
  standalone: true,
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceManualComponent {
  constructor(public router: Router) {}

  public redirect(route: string): void {
    this.router.navigate([`${route}`]);
  }
}
